import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DescriptionsComponent } from './descriptions.component';
import { DescriptionResolver } from './description.resolver';
import { DescriptionService } from './description.service';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  imports: [CommonModule, PipesModule],
  declarations: [DescriptionsComponent],
  providers: [DescriptionResolver, DescriptionService],
})
export class DescriptionsModule {}
